module.exports = __webpack_public_path__ + "static/media/icomoon.bb2dfb9d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/icomoon.ttf?v1g914
// module id = 247
// module chunks = 0